import { useEffect } from "react";

import Address from "lib/classes/address";
import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

import $ from "jquery";

import "styles/css/AddressTool.scss";

const AddressesPopup:Popup = new Popup({
	title: () => getLocaleString("addressestitle"),
	style: {
		height: "80%",
		width: "80%",
		minWidth: "300px",
		maxWidth: "700px"
	},
	styleContainer: {overflow: "hidden"},
	render: function() {
		const addresses:Address[] = this.get("addresses");
		const onAddressSelected:Function = this.get("selected");
		const onNextPageSelected:Function = this.get("next");
		const onPrevPageSelected:Function = this.get("prev");
		const currentPage:Number = this.get("page");
		const totalPages:Number = this.get("total");
		
		useEffect(() => scrollTop(), [currentPage]);
		
		const drawPageButtons = () => {
			if(totalPages <= 1) return;
			
			return (
				<>
					<div style={{float: "left"}}>
						<button onClick={() => onPrevPageSelected()} disabled={currentPage <= 1}>
							Previous
						</button>
					</div>
					<div style={{float: "right"}}>
						<button onClick={() => onNextPageSelected()} disabled={currentPage >= totalPages}>
							Next
						</button>
					</div>
				</>
			)
		}
		const scrollTop = () => {
			$("#addresses-list").scrollTop(0);
		}
		const getItems = () => {
			let items = [];
			
			for(let address of addresses) {
				items.push(
					<tr onClick={() => onAddressSelected(address)} key={addresses.indexOf(address)}>
						<td>{address.fullAddress}</td>
						<td>{address.postcode}</td>
					</tr>
				);
			}
			
			return items;
		}
		
		return (
			<div className="addr-container">
				<div id="addresses-list" className="addr-container__list">
					<table>
						<tbody>
							{getItems()}
						</tbody>
					</table>
				</div>
				<div className="addr-container__pages">
					{drawPageButtons()}
					<div style={{textAlign: "center", width: "100%", fontWeight: "bold"}}>
						Page {String(currentPage)} of {String(totalPages)}
					</div>
				</div>
			</div>
		)
	}
});

export default AddressesPopup;